import {
    OnInit,
    Component,
    ViewChild,
    ViewContainerRef,
    TemplateRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';

import { DatePipe } from '@angular/common';
import { Router, Event as NavigationEvent } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ProviderContext } from '../../data/Entities';
import { Advertise } from '../../data/Entities';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { setTimeout } from 'timers';
import { XHRBackend } from '@angular/http';

declare var jQuery: any;

@Component({
    selector: 'marketing',
    templateUrl: '/templates/get/Marketing/marketing',
})
export class Marketing implements OnInit {
    current_row: any;

    dtx: ProviderContext;
    adv: Advertise;
    rows: any = [];
    targetList: any = [];
    //  _rowCount: number = 50;
    c1List: any = [];
    c2List: any = [];
    c3List: any = [];
    fList: any = [];
    ppList: any = [];
    provList: any = [];

    c11List: any = [];
    c22List: any = [];
    c33List: any = [];

    funcList: any = [];
    funcKey: number;
    funcKeyNew: string = '';

    searchText: string;
    searchTargetText: string;
    searchProvider: string = '';
    searchC1: string = '';
    searchC2: string;
    searchC3: string;
    searchF: string; //functional
    advertiseProd: string; //functional

    searchC11: string = '';
    searchC22: string;
    searchC33: string;

    public modalRef: BsModalRef;
    public errstr = '';
    sourceProd: any;
    crawlStatusID: string = '';
    branded: boolean;
    isNotAvailable: boolean;
    isNew: boolean;
    isOffer: boolean;
    noFunctionalName: boolean;
    BioFilter: boolean;
    GlutFilter: boolean;
    HuFilter: boolean;
    LactFilter: boolean;
    SugFilter: boolean;
    VegFilter: boolean;
    NotMatchedFilter: boolean;
    sourceProdArr: any = [];
    groupActionVisible: boolean;
    groupAction: string;
    promotionID: number = 0;
    promotionURL: string = '';
    actualCategoryID: number;
    hasPromotion: boolean;
    pictureFile: any;
    promList1: any = [];
    promList2: any = [];
    promList3: any = [];
    activePromotions: any = [];
    productPromotions: any = [];
    public isNewFuncKey: boolean = false;
    //public isFuncKeyEdit: boolean = false;
    public funcKeyEdit: any = null;
    public funcKeyCurrent: any = null;
    promoImgWidth;
    promoImgHeight;

    @ViewChild('mergetemplate')
    private mergeTemplateRef: TemplateRef<any>;

    constructor(
        public siteServices: SiteServices,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        public viewRef: ViewContainerRef,
        private router: Router
    ) {
        this.dtx = new ProviderContext({
            ProviderCode: 'PRODUCT',
            SortField: 'ProductID',
            IsAsc: false,
            //ItemsPerPage: this._rowCount
        });

        //this.dtx.SortField = "UserID";
        //this.dtx.IsAsc = true;
        // this.dtx.FilterList.push(new Filter("SignProcessType", "USER", "_proctype"))
        //this._rowCount = this.dtx.RowCount;

        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETROOTCATEGORYLIST',
            {},
            (data) => {
                this.c1List = data.TagObject;
                this.c11List = data.TagObject;
                this.promList1 = data.TagObject;
            }
        );

        this.siteServices.provider_Execute(
            'POPULARPRODUCT',
            'GETPOPULARPRODUCT',
            {},
            (data) => {
                console.log(data);
                this.ppList = data.TagObject;
            }
        );

        this.siteServices.provider_GetAll(
            { ProviderCode: 'PROVIDER' },
            (data) => {
                this.provList = data.TagObject;
            }
        );

        this.refresh(true);
        this.refreshActivePromotions();
        this.refreshProductPromotions();
    }

    ngOnInit() {
        // jQuery(".mdb-select").material_select();
    }

    refresh(needCount: boolean) {
        this.groupActionVisible = false;
        this.groupAction = null;

        this.dtx.FilterList = [];
        this.dtx.addFilter('ProviderID', this.searchProvider);
        this.dtx.addFilter('ProductName', this.searchText);
        if (this.crawlStatusID)
            this.dtx.addFilter('CrawlStatusID', this.crawlStatusID);
        if (this.branded) this.dtx.addFilter('Branded', '1');
        if (this.isNotAvailable) this.dtx.addFilter('IsNotAvailable', '1');
        if (this.isOffer) this.dtx.addFilter('IsOffer', '1');
        if (this.isNew) this.dtx.addFilter('IsNew', '1');
        if (this.noFunctionalName) this.dtx.addFilter('NoFunctionalName', '1');
        if (this.BioFilter) this.dtx.addFilter('BioFilter', '1');
        if (this.GlutFilter) this.dtx.addFilter('GlutFilter', '1');
        if (this.HuFilter) this.dtx.addFilter('HuFilter', '1');
        if (this.LactFilter) this.dtx.addFilter('LactFilter', '1');
        if (this.SugFilter) this.dtx.addFilter('SugFilter', '1');
        if (this.VegFilter) this.dtx.addFilter('VegFilter', '1');
        if (this.NotMatchedFilter) this.dtx.addFilter('NotMatchedFilter', '1');

        if (this.searchF) this.dtx.addFilter('FunctionalID', this.searchF);
        else if (this.searchC3) this.dtx.addFilter('CategoryID', this.searchC3);
        else if (this.searchC2)
            this.dtx.addFilter('CategoryGroupID', this.searchC2);
        else if (this.searchC1)
            this.dtx.addFilter('CategoryGroupID', this.searchC1);

        this.rows = [];

        this.siteServices.provider_GetPage(this.dtx, (data) => {
            this.rows = data.TagObject;
            this.dtx.TotalItems = data.Tag;
        });
    }

    chgcat1(ev) {
        let cid = ev.target.value;

        this.c2List = [];
        this.searchC2 = '';
        this.c3List = [];
        this.searchC3 = '';
        this.fList = [];
        this.ppList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }

        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c2List = data.TagObject.ChildList;
            }
        );
    }

    chgcat2(ev) {
        let cid = ev.target.value;

        this.c3List = [];
        this.searchC3 = '';
        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c3List = data.TagObject.ChildList;
                if (this.c3List.length == 0) {
                    //LEVÉL - lehet gyneve
                    this.siteServices.provider_Execute(
                        'PRODUCT',
                        'GETFUNCTIONALNAMES',
                        { targetCategory: cid },
                        (data) => {
                            this.fList = data.TagObject;
                        }
                    );
                }
            }
        );
    }

    chgcat3(ev) {
        let cid = ev.target.value;

        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }
        this.siteServices.provider_Execute(
            'PRODUCT',
            'GETFUNCTIONALNAMES',
            { targetCategory: cid },
            (data) => {
                this.fList = data.TagObject;
            }
        );
    }

    chgcat11(ev) {
        let cid = ev.target.value;
        this.c33List = [];
        this.searchC33 = '';
        if (!cid) {
            this.c22List = [];
            this.searchC22 = '';
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c22List = data.TagObject.ChildList;
                this.searchC22 = '';
            }
        );
    }

    chgcat22(ev) {
        let cid = ev.target.value;
        if (!cid) {
            this.c33List = [];
            this.searchC33 = '';
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c33List = data.TagObject.ChildList;
                this.searchC33 = '';
            }
        );
    }

    pageChanged(ev) {
        this.dtx.Page = ev.page;
        this.refresh(false);
    }

    onSort(_sortField) {
        if (this.dtx.SortField == _sortField) {
            this.dtx.IsAsc = !this.dtx.IsAsc;
        } else {
            this.dtx.SortField = _sortField;
            this.dtx.IsAsc = true;
        }
        this.refresh(false);
    }

    editUser(id) {
        this.router.navigate(['useredit', id]).then((_ev) => {});
    }

    public advertiseProduct(sourcep: any) {
        console.log(sourcep);

        this.sourceProd = sourcep;
        this.sourceProdArr = sourcep.ProductName.split(' ');
        var rateFactor = this.advertiseProduct + sourcep.productID;
        this.advertiseProd;

        let adv: Advertise = new Advertise({
            ProductID: sourcep.ProductID,
            Ratefactor: this.advertiseProd,
        });

        this.siteServices.provider_Execute(
            'PRODUCT',
            'ADVERTISE',
            adv,
            (data) => {
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success(
                        'Termék kiemelve: -' + sourcep.ProductName
                    );
                }, 500);
            }
        );
        this.refresh(true);
    }

    public addSearch(token: string) {
        this.searchTargetText += ' ' + token;
    }

    public searchTargetList() {
        let dtx2: ProviderContext = new ProviderContext({
            ProviderCode: 'PRODUCT',
            SortField: 'ProductName',
            IsAsc: true,
            ItemsPerPage: 100000,
        });

        dtx2.addFilter('ProductName', this.searchTargetText);
        // dtx2.addFilter("CategoryID", this.sourceProd.CategoryID);
        dtx2.addFilter('MatchSourceProductID', this.sourceProd.ProductID);
        this.siteServices.inProgress = true;
        this.siteServices.provider_Execute(
            'PRODUCT',
            'FINDMATCHING',
            dtx2,
            (data) => {
                //szürés hasonló bolt
                this.targetList = data.TagObject;
                this.siteServices.inProgress = false;
            }
        );
    }

    delAdvStatus(pid, p) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'DELADV',
            { productID: pid },
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Termék kiemelése megszűntetve');
                }, 500);
                p.remove();
            }
        );
    }

    doFunctionalGroup(fkey) {
        let arr = this.rows
            .filter((x) => x._selected)
            .map((y) => {
                return y.ProductID;
            });
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETFUNCTIONALNAME',
            { productArr: arr, targetFunctionalID: fkey },
            (data) => {
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success(
                        'Beállítás OK -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    chgProm1(event) {
        this.actualCategoryID = event.target.value;
        this.clearPromotionData();
        this.promList2 = [];
        this.promList3 = [];

        if (!this.actualCategoryID) {
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: this.actualCategoryID },
            (data) => {
                this.promList2 = data.TagObject.ChildList;
            }
        );
        this.getPromotion(this.actualCategoryID);
    }

    chgProm2(event) {
        this.promList3 = [];
        this.clearPromotionData();
        if (!event.target.value) {
            return;
        }
        this.actualCategoryID = event.target.value;

        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: this.actualCategoryID },
            (data) => {
                this.promList3 = data.TagObject.ChildList;
            }
        );
        this.getPromotion(this.actualCategoryID);
    }

    chgProm3(event) {
        this.actualCategoryID = event.target.value;
        this.clearPromotionData();
        if (!this.actualCategoryID) {
            return;
        }
        this.getPromotion(this.actualCategoryID);
    }

    getPromotion(categoryID) {
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETPROMOTION',
            { CategoryID: categoryID },
            (data) => {
                let result = data.TagObject.Result;
                if (result) {
                    this.promotionID = result.PromotionID;
                    this.promotionURL = result.PromotionURL;
                    this.pictureFile = 'data:image/png;base64,'.concat(
                        result.PromotionPicture
                    );
                }
                this.hasPromotion = this.promotionID > 0 ? true : false;
            }
        );
    }

    setPromotion() {
        if (
            !this.promoImgWidth ||
            (this.promoImgHeight && this.promoImgWidth <= 0) ||
            this.promoImgHeight <= 0
        ) {
            this.siteServices.error(
                'Tölts fel egy promóciós képet a mentéshez!'
            );
            return;
        }

        let imageRatio =
            Math.round((this.promoImgWidth / this.promoImgHeight) * 100) / 100;

        if (imageRatio < 5.5 || imageRatio > 6.5) {
            this.siteServices.error(
                `A Promóciós képnek az aránya (5,5 x 1) és (6,5 x 1) között kell lennie 'Szélesség x Magasság'! Aktuális kép méret: ${this.promoImgWidth} x ${this.promoImgHeight}, és az arány: ${imageRatio}!`
            );
            return;
        }

        this.siteServices.provider_Execute(
            'CATEGORY',
            'SETPROMOTION',
            {
                CategoryID: this.actualCategoryID,
                PromotionID: this.promotionID,
                PromotionURL: this.promotionURL,
                PromotionPicture: this.pictureFile,
            },
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Promóció elmentve');
                }, 500);
                this.refreshActivePromotions();
            }
        );
        this.getPromotion(this.actualCategoryID);
    }

    delPromotion(categoryID) {
        this.siteServices.provider_Execute(
            'CATEGORY',
            'DELPROMOTION',
            { CategoryID: categoryID },
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Promóció törölve');
                }, 500);
                this.refreshActivePromotions();
            }
        );
        this.clearPromotionData();
    }

    onFileSelected(event) {
        let reader = new FileReader();
        let file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = () => {
            let img = new Image();
            img.onload = () => {
                this.promoImgWidth = img.width;
                this.promoImgHeight = img.height;
            };
            this.pictureFile = reader.result;
            img.src = this.pictureFile;
        };
    }

    clearPromotionData() {
        this.promotionURL = '';
        this.pictureFile = null;
        this.promotionID = 0;
    }

    refreshActivePromotions() {
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETACTIVEPROMOTIONS',
            {},
            (data) => {
                this.activePromotions = data.TagObject;
            }
        );
    }

    delProductPromotion(productID) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'DELPROMOTION',
            { ProductID: productID },
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Promóció törölve');
                }, 500);
                this.refreshProductPromotions();
            }
        );
        this.clearPromotionData();
    }

    refreshProductPromotions() {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'GETACTIVEPROMOTIONS',
            {},
            (data) => {
                this.productPromotions = data.TagObject;
            }
        );
    }
}
